import { useEffect } from "react";

export default function PrerenderReady() {
  useEffect(() => {
    window.prerenderReady = true;
    console.log("prerenderReady");
  }, []);
  return null;
}
